import classNames from "@/utils/classNames";
import { ButtonHTMLAttributes } from "react";

export default function SecondaryButton({
    type = "button",
    className = "",
    disabled,
    children,
    ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <button
            data-testid="secondary-action-button"
            {...props}
            type={type}
            className={classNames(
                "inline-flex items-center justify-center rounded-full border border-brand-red bg-white px-8 py-2 font-medium text-brand-red shadow-xs transition duration-150 ease-in-out hover:bg-brand-secondaryButtonHover active:bg-brand-secondaryButtonClick disabled:opacity-25",
                disabled ? "opacity-25" : "",
                className,
            )}
            disabled={disabled}
        >
            {children}
        </button>
    );
}
